var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LineChartGenerator',{attrs:{"id":"lineChart","data":_vm.lineChartData}})
}
var staticRenderFns = []

export { render, staticRenderFns }